import { ComponentEuiCallout, ComponentEuiText } from 'Component'


const ComponentNavFormCalloutUnauthorized = () => {
    return <ComponentEuiCallout iconType={'alert'} color={'danger'} title={'Action Unauthorised'}>{
        <ComponentEuiText><p>You do not have the required authorization for this action</p></ComponentEuiText>
    }</ComponentEuiCallout>
}

export default ComponentNavFormCalloutUnauthorized